import getAnswerService from './getAnswerService';

export default async (appKey, filename = '', func = '', messagge = '') => {
    const answerService = await getAnswerService();
    const answer = await answerService.getAnswer(appKey);
    const stampedValue = `${filename}-${func}-${messagge} | ${new Date().toISOString()}`;
    const value = answer.value && answer.value.length > 0 ? answer.value.concat(stampedValue) : stampedValue;
    answerService.saveAnswer({
      appkey: appKey,
      value,
      timestamp: new Date()
    });
}